import React, { useState } from 'react';
import PropTypes from 'prop-types'
import DashboardTableContainer from './DashboardTable/DashboardTable.container';
import DashboardTodayContainer from './DashboardToday/DashboardToday.container';
import DashboardChartContainer from './DashboardChart/DashboardChart.container';
import AggregationInfoChart from '../../AggregationInfoChart/AggregationInfoChart.container';
import PageHeading from "../../PageHeading";
import config from "../../../config";
import localStorage from "../../../helpers/localStorage";
import { withTranslation } from '../../ChildrenContext';
import CustomTooltip from '../../Tooltip';
import moment from 'moment-timezone';
import UserStore from '../../../stores/UserStore';

const nameLocalStorage = 'showChart';

const images = {
    hide: require('img/chart/chart-hide.svg'),
    show: require('img/chart/chart-show.svg')
};

// "UTC+2", "UTC-3:30", "UTC"
const formatUtcOffset = (timezone) => {
    const offset = moment.tz(timezone).utcOffset();
    if (!offset) {
        return 'UTC';
    }
    const sign = offset > 0 ? '+' : '-';
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    return `UTC${sign}${hours}${minutes ? ':' + String(minutes).padStart(2, '0') : ''}`;
};

const getUtcNote = (staticNames) => {
    const timezone = UserStore.getValidTimeZone();
    const offset = formatUtcOffset(timezone);
    const shortNote = staticNames.utcNote || 'Chart and table data are shown in the UTC time zone';

    // user's time currently matches UTC — no need to repeat the timezone
    if (offset === 'UTC') {
        return shortNote;
    }

    return (staticNames.utcNoteWithTimezone || 'Chart and table data are shown in the UTC time zone (your time zone: %timezone%, %offset%)')
        .replace('%timezone%', timezone)
        .replace('%offset%', offset);
};

const DashboardPage = (props) => {
    const staticNames = (props.t && props.t.dashboard) || {};

    const [showChart, setShowChart] = useState(() => {
        if (!localStorage.get(nameLocalStorage)) {
            localStorage.set(nameLocalStorage, config.defaultShowChart);
        }
        return 'show' === localStorage.get(nameLocalStorage);
    });

    const getChartShowHideIcon = (status) => {
        if (status) {
            return (
                <img src={images.show} alt={staticNames.show} title={staticNames.show}/>
            );
        }

        return (
            <img src={images.hide} alt={staticNames.hide} title={staticNames.hide}/>
        );
    };

    const getDashboardChartContainer = () => {
        if (showChart) {
            return (
                <DashboardChartContainer/>
            );
        }
    };

    const hideShowChart = (e) => {
        e.preventDefault();

        localStorage.set(nameLocalStorage, !showChart ? 'show' : 'hide');

        setShowChart(!showChart);
    };

    return (
        <div className="dashboard">
            <PageHeading title={staticNames.title || "Dashboard"} />

            <AggregationInfoChart />

            <section className="wrapper-content" id="dashboardPage">
                <h3>{staticNames.period}</h3>

                <DashboardTodayContainer/>

                <div className={'toolbar__view'}>
                    <h3>{staticNames.lastPeriod}</h3>
                    <CustomTooltip id={`toggleChartTooltip`} tooltip={showChart ? staticNames.hideChart : staticNames.showChart}>
                        <button
                            className={`show-hide-chart btn`}
                            onClick={e => hideShowChart(e)}
                        >
                            {getChartShowHideIcon(showChart)}
                        </button>
                    </CustomTooltip>
                </div>
                <p className="dashboard__utc-note">{getUtcNote(staticNames)}</p>

                {getDashboardChartContainer()}

                <div className="ibox weekly">
                    <div className="ibox-content">
                        <DashboardTableContainer/>
                    </div>
                </div>
            </section>
        </div>
    );
};

DashboardPage.propTypes = {
    t: PropTypes.object
};

export default withTranslation(DashboardPage);
